import React from "react"
import { Link, graphql } from "gatsby"
import { Link as ScrollLink } from "react-scroll"
import { StaticImage } from "gatsby-plugin-image"

import Layout from "../../components/layout"
import PostContentHeader from "../../components/post-content-header"
import PostMainImage from "../../components/post-main-image"
import CategoryDateShare from "../../components/category-date-share"
import Seo from "../../components/seo"

import _ from 'lodash'
import ogImage from "../../images/posts/72/thumb-landscape.png"

const Post72 = ({ data: { allCategoryJson, postsJson, allPostsJson }, location }) => {

  const category = _.find(allCategoryJson.edges, (edge) => {
    return edge.node.categoryId === postsJson.categoryId
  }).node

  // 表示したい記事IDを手動で指定（順番もこの通りに表示）
  const relatedPostIds = [73, 69, 74]

  const relatedPosts = relatedPostIds
    .map((id) => allPostsJson.edges.find(({ node }) => node.postId === id)?.node)
    .filter(Boolean)

return (
<Layout>
  <Seo title={postsJson.title} description={postsJson.description} ogImage={ogImage} />
  <div className="posts">
    <PostContentHeader categoryName={category.nameJA} postTitle={postsJson.title} location={location} />
    <section id="pickup-article">
      <PostMainImage post={postsJson} />
      <div className="description wrapper text-two-cloumn">
        <CategoryDateShare category={category} post={postsJson} />
        <div className="title">
          <h1>{postsJson.title}</h1>
          <p>旅行の準備をするとき、バッグ選びで迷ったことはありませんか。</p>
          <p>「せっかくだからお気に入りのブランドバッグを持っていきたい。でも傷つけたら……」「旅行用に新しいバッグを買うほどでもないけど、いつものバッグじゃ気分が出ない」——そんなふうに感じている方は多いと思います。</p>
          <p>旅行とブランドバッグの組み合わせは、実はとても相性がいい。旅行は非日常だからこそ、バッグひとつで気分が上がる効果が大きく、普段より少し特別なバッグを持ちたくなるのは自然なことです。<br></br>
          そして旅行中の写真には、バッグも一緒に写ります。手元のバッグ、テーブルに置いたバッグ——気に入ったひとつがあると、旅の写真がもう少し好きになれる。ただ、思い出を振り返ったとき、毎回同じバッグが写っていると気になる、という方もいるのではないでしょうか。旅行ごとに気分やシーンに合わせてバッグを替えられたら——そのための選択肢についても、この記事でお伝えします。<br></br>
          シーンによって「持っていくべきバッグ」は変わります。夏旅行・国内旅行・女子旅のシーン別に、ブランドバッグの選び方を見ていきましょう。</p>
        </div>
      </div>
    </section>
    <div className="wrapper">
    <section className="bag-content">
      <div className="text-two-cloumn">
        <h2 style={{color: "#0a9186"}}>目次</h2>
        <p>
          <div style={{margin: "1rem 0"}}>
            <ScrollLink className="scroll" to="sec1" smooth={true} duration={500} offset={-80} style={{fontSize: "2rem"}}><span style={{color: "#0a9186"}}>1 |</span>&nbsp;&nbsp;旅行にブランドバッグ、持っていくべき？</ScrollLink>
          </div>
          <div style={{margin: "1rem 0"}}>
            <ScrollLink className="scroll" to="sec2" smooth={true} duration={500} offset={-80} style={{fontSize: "2rem"}}><span style={{color: "#0a9186"}}>2 |</span>&nbsp;&nbsp;夏旅行・リゾートに持っていきたいバッグ</ScrollLink>
          </div>
          <div style={{margin: "1rem 0"}}>
            <ScrollLink className="scroll" to="sec3" smooth={true} duration={500} offset={-80} style={{fontSize: "2rem"}}><span style={{color: "#0a9186"}}>3 |</span>&nbsp;&nbsp;国内旅行・街歩きに持っていきたいバッグ</ScrollLink>
          </div>
          <div style={{margin: "1rem 0"}}>
            <ScrollLink className="scroll" to="sec4" smooth={true} duration={500} offset={-80} style={{fontSize: "2rem"}}><span style={{color: "#0a9186"}}>4 |</span>&nbsp;&nbsp;女子旅に持っていきたいバッグ</ScrollLink>
          </div>
          <div style={{margin: "1rem 0"}}>
            <ScrollLink className="scroll" to="sec5" smooth={true} duration={500} offset={-80} style={{fontSize: "2rem"}}><span style={{color: "#0a9186"}}>5 |</span>&nbsp;&nbsp;旅行ごとに借り替える、という選択肢</ScrollLink>
          </div>
          <div style={{margin: "1rem 0"}}>
            <ScrollLink className="scroll" to="sec6" smooth={true} duration={500} offset={-80} style={{fontSize: "2rem"}}><span style={{color: "#0a9186"}}>6 |</span>&nbsp;&nbsp;よくある疑問</ScrollLink>
          </div>
          <div style={{margin: "1rem 0"}}>
            <ScrollLink className="scroll" to="sec7" smooth={true} duration={500} offset={-80} style={{fontSize: "2rem"}}><span style={{color: "#0a9186"}}>7 |</span>&nbsp;&nbsp;まとめ：旅先でも、好きなバッグを</ScrollLink>
          </div>
        </p>
      </div>
      <section name="sec1" className="section-content">
        <div>
          <h2>旅行にブランドバッグ、持っていくべき？</h2>
        </div>
        <p>結論から言うと、旅行にブランドバッグを持っていくのはありです。<br></br>
        旅先という非日常の空間こそ、お気に入りのバッグが映えるシーンでもあります。</p>
        <p>ただし、旅行のシーンに合ったバッグを選ぶことが大切です。どんなに好きなバッグでも、移動が多い旅行で重いバッグを持ち続けるのは疲れますし、リゾートでかしこまったバッグを持っていても浮いてしまいます。</p>
        <p>シーン別の選び方を見ていきましょう。</p>
      </section>
      <section name="sec2" className="section-content">
        <div>
          <h2>夏旅行・リゾートに持っていきたいバッグ</h2>
        </div>
        <p>海・リゾート・夏の旅行で大切なのは、「軽さ」「明るさ」「カジュアルさ」の3つです。</p>
        <div className="mt4">
          <h3>◆ 選び方のポイント</h3>
          <p><b className="text-font-bolder">重さ：</b>観光や移動が多いリゾートでは、バッグ自体が軽いものを選ぶと疲れにくい。革製のバッグよりも、キャンバス素材やナイロン素材が向いています。</p>
          <p><b className="text-font-bolder">色・素材：</b>夏の明るいコーデに合わせるなら、ホワイト系・ベージュ系・明るいカラーが映えます。モノグラムキャンバスのような柄ものも、夏の光の中で存在感が出ます。</p>
          <p><b className="text-font-bolder">サイズ：</b>観光中は両手が使えた方が便利なことも多いため、ショルダーやクロスボディで使えるものが重宝します。</p>
        </div>
        <div className="mt4">
          <h3>◆ おすすめのブランド・モデルの傾向</h3>
          <p>ルイ・ヴィトンのモノグラムキャンバス素材は軽くて耐久性があり、リゾートにも映えます。セリーヌのトリオンフキャンバスも軽さと上品さのバランスが良く、リゾートスタイルに合わせやすいモデルです。</p>
        </div>
      </section>
      <figure className="mt8">
          <StaticImage src="../../images/posts/72/1.png" alt=""/>
      </figure>
      <section name="sec3" className="section-content">
        <div>
          <h2>国内旅行・街歩きに持っていきたいバッグ</h2>
        </div>
        <p>京都・金沢・鎌倉など、街を歩きながら観光するスタイルの旅行では、「収納力」「使いやすさ」「コーデの汎用性」が重要になります。</p>
        <div className="mt4">
          <h3>◆ 選び方のポイント</h3>
          <p><b className="text-font-bolder">収納力：</b>観光しながら地図・財布・日傘・お土産の小物……と荷物は意外と増えます。口が大きく開いて出し入れしやすいトートタイプや、マチのあるバッグが便利です。</p>
          <p><b className="text-font-bolder">歩きやすさ：</b>石畳や坂道が多い観光地では、両手が使えるショルダーやリュックタイプが向いています。一方で、きれいめのレストランやホテルでも違和感のないデザインを選ぶと、1泊2日を通して使いやすいのでおすすめ。</p>
          <p><b className="text-font-bolder">コーデの汎用性：</b>観光・食事・ショッピングと場面が変わっても合わせやすい、カジュアルすぎずフォーマルすぎないデザインが重宝します。</p>
        </div>
        <div className="mt4">
          <h3>◆ おすすめのブランド・モデルの傾向</h3>
          <p>ルイ・ヴィトンのネヴァーフルは大容量で軽く、国内旅行の定番として選ばれることが多いモデルです。グッチのトートも収納力と汎用性のバランスが良く、街歩きに馴染みます。</p>
        </div>
      </section>
      <section name="sec4" className="section-content">
        <div>
          <h2>女子旅に持っていきたいバッグ</h2>
        </div>
        <p>女子旅でのバッグ選びは、「見た目の華やかさ」と「使い勝手」の両立がポイントです。写真映えを意識しながらも、長時間一緒に行動するので実用性も外せません。</p>
        <div className="mt4">
          <h3>◆ 選び方のポイント</h3>
          <p><b className="text-font-bolder">写真映え：</b>女子旅では写真を撮る機会が多い。バッグが写真に入ったときに絵になるデザインを選ぶと、旅の思い出がより華やかになります。</p>
          <p><b className="text-font-bolder">コンパクトさ：</b>荷物をメインのスーツケースに預けて、日中はコンパクトなバッグで身軽に動くスタイルが女子旅では使いやすい。</p>
          <p><b className="text-font-bolder">話題性：</b>「そのバッグどこの？」と会話が生まれるバッグは、旅先でのコミュニケーションのきっかけにもなります。</p>
        </div>
        <div className="mt4">
          <h3>◆ おすすめのブランド・モデルの傾向</h3>
          <p>セリーヌのニノや、フェンディのバゲットのようなコンパクトでデザイン性の高いモデルは、女子旅の写真映えという観点でも人気です。ロエベのアナグラムトートなど、個性のあるモデルも旅先では存在感を発揮します。</p>
        </div>
      </section>
      <figure className="mt8">
          <StaticImage src="../../images/posts/72/2.jpg" alt=""/>
      </figure>
      <section name="sec5" className="section-content">
        <div>
          <h2>旅行ごとに借り替える、という選択肢</h2>
        </div>
        <p>旅行とブランドバッグのサブスクは、実は相性がとてもいい。</p>
        <p>旅行は「非日常」だからこそ、いつもとは違うバッグを持ちたくなるもの。でも旅行のたびにバッグを買い足すのは現実的ではありません。「夏のリゾートに合うバッグ」「女子旅に持っていきたいバッグ」と、シーンに合わせて借り替えられるのがサブスクの魅力のひとつです。</p>
        <p>ラクサスでは返却期限がないため、旅行が終わったあとも気に入ったバッグをそのまま使い続けることができます。逆に、「次の旅行では違うバッグを使いたい」と思ったら返却して、新しいバッグを選ぶだけ。</p>
        <p>傷への不安という観点でも、サブスクは旅行との相性が良い。ラクサスでは通常使用による傷や汚れは補償の対象です。「旅行中に傷をつけてしまったら」という心理的なプレッシャーなしに、旅先でもバッグを楽しめます。</p>
        <p>「今年の夏旅行には、いつもと違うバッグで」——そう思っている方は、まずアプリで在庫を確認してみてください。</p>
      </section>
      <figure className="mt8">
          <StaticImage src="../../images/posts/72/3.jpg" alt=""/>
      </figure>
      <section name="sec6" className="section-content">
        <div>
          <h2>よくある疑問</h2>
        </div>
        <dl className="faq-item mt4">
          <dt>Q. 旅行中にバッグが傷ついたらどうなりますか？</dt>
          <dd>
            <p>A. ラクサスでは、通常使用による細かい傷や汚れは補償の対象です。旅行中の日常的な使用で生じる変化については、気にせずお使いいただけます。心配な点はアプリのトーク機能でいつでもスタッフに確認できます。</p>
          </dd>
        </dl>
        <dl className="faq-item mt4">
          <dt>Q. 旅行前に間に合うように届けてもらえますか？</dt>
          <dd>
            <p>A. 発送のタイミングはアプリ内で確認できます。旅行の日程に合わせて余裕を持って予約されることをおすすめします。</p>
          </dd>
        </dl>
        <dl className="faq-item mt4">
          <dt>Q. 旅行に向いているブランドやモデルを教えてもらえますか？</dt>
          <dd>
            <p>A. アプリ内のトーク機能でスタッフに相談いただけます。旅行のシーンやスタイルをお伝えいただくと、おすすめのモデルをご提案できます。</p>
          </dd>
        </dl>
        <dl className="faq-item mt4">
          <dt>Q. 返却期限はありますか？</dt>
          <dd>
            <p>A. ありません。旅行が終わったあとも、気に入ったバッグをそのまま使い続けることができます。返却したいときに返却するスタイルです。</p>
          </dd>
        </dl>
        <dl className="faq-item mt4">
          <dt>Q. どんなブランドが借りられますか？</dt>
          <dd>
            <p>A. エルメス、シャネル、ルイ・ヴィトン、セリーヌ、グッチ、プラダ、フェンディ、ロエベなど60以上のブランド、約30,000点のバッグから選べます。無料の会員登録後にアプリ内で閲覧できます。</p>
          </dd>
        </dl>
      </section>
      <figure className="mt8">
          <StaticImage src="../../images/posts/72/4.jpg" alt=""/>
      </figure>
      <section name="sec7" className="section-content">
        <div>
          <h2>まとめ：旅先でも、好きなバッグを</h2>
        </div>
        <p>旅行は、普段とは違う自分を楽しめる時間です。いつもとは違うシーン、いつもとは違うコーデ——そこに、いつもとは違うバッグがあると、旅の記憶がもう少し鮮やかになる気がします。</p>
        <p>シーンに合ったバッグを選んで、旅先でも好きなバッグを楽しんでみてください。</p>
        <p>まずはアプリを無料でダウンロードして、どんなバッグが揃っているか見てみてください。「この夏の旅行に持っていきたい」と思えるバッグが見つかったら、そのときが始め時です。</p>
        <a href="https://laxus.co/dl" className="view-all-button">アプリを無料でダウンロードしてバッグを見てみる</a>
      </section>

      {relatedPosts.length > 0 && (
        <section className="section-content related-posts-section">
          <div>
            <h2>関連記事</h2>
          </div>
          <ul className="related-posts">
            {relatedPosts.map((node) => (
              <li key={node.postId}>
                <Link to={`/posts/${node.postId}`}>
                  <span className="date">{node.postedAt.substr(0, 10).replace(/-/g, '/')}</span>
                  <p className="title">{node.title}</p>
                </Link>
              </li>
            ))}
          </ul>
        </section>
      )}
      
    </section>
    </div>
  </div>
</Layout>
)}

export default Post72

export const pageQuery = graphql`
  query {
    postsJson(postId: {eq: 72}) {
      id
      title
      postId
      postedAt
      description
      categoryId
      authorId
      thumbnailSquare {
        src {
          childImageSharp {
            gatsbyImageData
          }
        }
      }
      thumbnailLandscape {
        src {
          childImageSharp {
            gatsbyImageData
          }
        }
      }
    }
    allPostsJson(sort: {fields: postedAt, order: DESC}) {
      edges {
        node {
          id
          title
          postId
          postedAt
        }
      }
    }
    allCategoryJson(sort: {fields: sortOrder}) {
      edges {
        node {
          id
          categoryId
          slug
          nameJA
          nameEN
          description
        }
      }
    }
  }
`
